<template>
  <button
    v-if="isMobileViewport"
    class="mobile-sidebar-fab"
    type="button"
    :aria-label="t('sidebar.mobile.openShortcuts')"
    @click="openMobileQuickMenu"
  >
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.4" d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  </button>

  <Teleport to="body">
    <div v-if="isMobileViewport && showMobileQuickMenu" class="mobile-sidebar-modal">
      <div class="mobile-sidebar-backdrop" @click="closeMobileQuickMenu"></div>
      <div class="mobile-sidebar-sheet">
        <div class="mobile-sheet-header">
          <h3>{{ t('sidebar.mobile.shortcutsTitle') }}</h3>
          <button type="button" class="mobile-sheet-close" @click="closeMobileQuickMenu">{{ t('common.close') }}</button>
        </div>

        <div class="mobile-actions-grid">
          <button class="mobile-action-tile" @click="goHomeMobile">
            <span class="tile-icon">🏠</span>
            <span class="tile-label">{{ t('sidebar.mobile.home') }}</span>
          </button>
          <button class="mobile-action-tile" @click="openCreateModalMobile">
            <span class="tile-icon">➕</span>
            <span class="tile-label">{{ t('sidebar.mobile.newWorkspace') }}</span>
          </button>
          <button class="mobile-action-tile" @click="toggleThemeMobile">
            <span class="tile-icon">{{ isLightTheme ? '🌙' : '☀️' }}</span>
            <span class="tile-label">{{ t('sidebar.mobile.theme') }}</span>
          </button>
          <button class="mobile-action-tile" @click="goToProfileMobile">
            <span class="tile-icon">👤</span>
            <span class="tile-label">{{ t('sidebar.mobile.profile') }}</span>
          </button>
          <button class="mobile-action-tile danger" @click="handleLogoutMobile">
            <span class="tile-icon">🚪</span>
            <span class="tile-label">{{ t('sidebar.mobile.logout') }}</span>
          </button>
        </div>

        <div class="mobile-workspaces-title">{{ t('sidebar.mobile.workspaces') }}</div>
        <div class="mobile-workspaces-grid">
          <button
            v-for="workspace in orderedWorkspaces"
            :key="`mobile-${workspace.id}`"
            class="mobile-workspace-item"
            :class="{ active: currentWorkspace?.id === workspace.id }"
            :style="{
              '--mobile-ws-color': workspace.corWorkspace || '#5865F2',
              '--mobile-ws-color-light': adjustColorLightness(workspace.corWorkspace || '#5865F2', 18)
            }"
            @click="selectWorkspaceMobile(workspace)"
          >
            <div class="mobile-workspace-avatar">
              <img
                v-if="workspace.fotoWorkspace && workspace.fotoWorkspace.trim() !== '' && !failedImages.has(workspace.id)"
                :src="workspaceMediaSrc(workspace.fotoWorkspace)"
                :alt="workspace.nome"
                class="mobile-workspace-image"
                @error="handleImageError"
              />
              <component
                v-else
                :is="getIconComponent(workspace.icone)"
                class="mobile-workspace-icon"
              />
            </div>
            <span class="mobile-workspace-name">{{ workspace.nome }}</span>
          </button>
        </div>
      </div>
    </div>
  </Teleport>

  <div class="workspace-sidebar premium-sidebar">
    <!-- Header da Sidebar -->
    <!-- <div class="sidebar-header">
      <div class="sidebar-logo">
        <div class="logo-icon">
          <svg class="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
        </div>
        <div class="logo-text">
          <span class="logo-title">Backlog</span>
          <span class="logo-subtitle">Workspaces</span>
        </div>
      </div>
    </div> -->

    <!-- Botão Home Premium -->
    <div class="sidebar-section">
      <div class="section-title">
        <!-- <span>Navegação</span> -->
      </div>
    <div class="sidebar-item group home-button" :class="{ 'active': isHome }">
      <button 
        @click="goHome"
          class="workspace-icon home-icon premium-button"
        :class="{ 'active': isHome }"
      >
          <div class="icon-container">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
        </svg>
          </div>
          <div class="button-glow"></div>
      </button>
        <!-- Indicador ativo premium -->
        <!-- <div v-if="isHome" class="active-indicator premium-indicator"></div> -->
      </div>
    </div>

    <!-- Separador Premium -->
    <!-- <div class="premium-separator"></div> -->

    <!-- Seção de Workspaces Premium -->
    <div class="sidebar-section workspace-section">
      <div class="section-header">
        <!-- <div class="section-title">
           <span>Workspaces</span> 
           <span class="workspace-count">{{ orderedWorkspaces.length }}</span> 
        </div> -->
        <button 
          @click="openCreateModal"
          class="add-workspace-btn premium-add-btn"
          :title="t('sidebar.createWorkspaceTitle')"
        >
          <div class="add-icon">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg>
          </div>
          <div class="add-glow"></div>
        </button>
      </div>
      
      <!-- Lista de Workspaces Premium -->
    <div 
      ref="workspaceList"
        class="workspace-list premium-workspace-list"
    >
      <div 
        v-for="workspace in orderedWorkspaces" 
        :key="workspace.id"
        :data-id="workspace.id"
          class="sidebar-item group workspace-item premium-workspace-item"
        :class="{ 'active': currentWorkspace?.id === workspace.id }"
      >
        <button 
          @click="selectWorkspace(workspace)"
          @contextmenu.prevent="showContextMenu(workspace, $event)"
          @mouseenter="showWorkspaceInfo(workspace, $event)"
          @mouseleave="hideWorkspaceInfo"
            class="workspace-icon premium-workspace-button"
          :class="{ 'active': currentWorkspace?.id === workspace.id }"
          :style="workspace.fotoWorkspace && workspace.fotoWorkspace.trim() !== '' ? 
            { 
              '--workspace-color': workspace.corWorkspace || '#5865F2',
              '--workspace-color-light': adjustColorLightness(workspace.corWorkspace || '#5865F2', 20)
            } : 
            { 
              backgroundColor: workspace.corWorkspace || '#5865F2',
              '--workspace-color': workspace.corWorkspace || '#5865F2',
              '--workspace-color-light': adjustColorLightness(workspace.corWorkspace || '#5865F2', 20)
            }"
        >
            <!-- Container da imagem/ícone -->
            <div class="workspace-content" v-if="workspace.fotoWorkspace && workspace.fotoWorkspace.trim() !== '' && !failedImages.has(workspace.id)">
          <!-- Exibir foto se disponível e não falhou -->
          <img 
            :src="workspaceMediaSrc(workspace.fotoWorkspace)"
            :alt="workspace.nome"
                class="premium-workspace-image"
            @error="handleImageError"
          />
              
              <!-- Overlay de hover -->
              <div class="workspace-overlay"></div>
              
              <!-- Efeito de brilho -->
              <div class="workspace-shine"></div>
            </div>
            <!-- Exibir ícone quando não houver foto ou quando a imagem falhar -->
            <div class="workspace-content" v-else>
              <component 
                :is="getIconComponent(workspace.icone)" 
                    class="premium-workspace-icon" 
                  />
                  
                  <!-- Overlay de hover -->
                  <div class="workspace-overlay"></div>
                  
                  <!-- Efeito de brilho -->
                  <div class="workspace-shine"></div>
                </div>
          </button>
          
          <!-- Indicador ativo premium -->
          <!-- <div v-if="currentWorkspace?.id === workspace.id" class="active-indicator premium-indicator workspace-indicator"></div> -->
      </div>
    </div>

    <!-- Menu de Contexto Premium - Renderizado fora da sidebar -->
    <Teleport to="body">
    <div 
      v-if="showContextMenuState" 
        class="context-menu premium-context-menu"
      :style="contextMenuPosition"
      @click.stop
    >
      <div class="premium-panel-mesh" aria-hidden="true" />
      <div class="premium-panel-glow" aria-hidden="true" />
      <div class="context-menu-header premium-panel-header">
        <div class="context-workspace-icon">
          <img 
            v-if="contextMenuWorkspace?.fotoWorkspace && contextMenuWorkspace.fotoWorkspace.trim() !== ''" 
            :src="workspaceMediaSrc(contextMenuWorkspace.fotoWorkspace)"
            :alt="contextMenuWorkspace.nome"
            class="context-workspace-image"
          />
          <component 
            v-else 
            :is="getIconComponent(contextMenuWorkspace?.icone)" 
            class="context-workspace-icon-svg" 
          />
        </div>
        
        <div class="context-workspace-info">
          <p class="context-workspace-eyebrow">
            <span class="context-workspace-eyebrow-dot" aria-hidden="true" />
            {{ t('sidebar.contextMenu.eyebrow') }}
          </p>
          <h3 class="context-workspace-name">{{ contextMenuWorkspace?.nome }}</h3>
          <div class="context-workspace-chips">
            <span class="context-workspace-chip">{{ workspaceTypeLabel(contextMenuWorkspace?.tipo) }}</span>
            <span class="context-workspace-chip context-workspace-chip--accent">
              <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              {{ t('sidebar.contextMenu.active') }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="context-menu-divider"></div>
      
      <div class="context-menu-options">
        <button
          v-if="isPreviewSidebarWorkspace(contextMenuWorkspace)"
          class="context-menu-option group"
          @click="removeFromSidebar(contextMenuWorkspace)"
        >
          <div class="option-icon">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
            </svg>
          </div>
          <div class="option-content">
            <span class="option-title">{{ t('sidebar.contextMenu.removeFromSidebarTitle') }}</span>
            <span class="option-subtitle">{{ t('sidebar.contextMenu.removeFromSidebarSubtitle') }}</span>
          </div>
        </button>

        <template v-if="!isPreviewSidebarWorkspace(contextMenuWorkspace)">
        <button class="context-menu-option edit-option group" @click="editWorkspace(contextMenuWorkspace)">
          <div class="option-icon">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
        </svg>
      </div>
          <div class="option-content">
            <span class="option-title">{{ t('sidebar.contextMenu.editTitle') }}</span>
            <span class="option-subtitle">{{ t('sidebar.contextMenu.editSubtitle') }}</span>
          </div>
          <div class="option-arrow">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </div>
        </button>
        
        <button class="context-menu-option delete-option group" @click="deleteWorkspace(contextMenuWorkspace)">
          <div class="option-icon delete-icon">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
        </svg>
      </div>
          <div class="option-content">
            <span class="option-title">{{ t('sidebar.contextMenu.deleteTitle') }}</span>
            <span class="option-subtitle">{{ t('sidebar.contextMenu.deleteSubtitle') }}</span>
    </div>
          <div class="option-arrow">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
          </div>
      </button>
        </template>
    </div>
    </div>
    </Teleport>

    <!-- Separador Premium -->
    <div class="premium-separator"></div>

    <!-- Seção de Controles -->
    <div class="sidebar-section controls-section">
      <div class="section-title">
        <!-- <span>Controles</span> -->
      </div>

    <!-- Botão de alternância de tema -->
    <div class="sidebar-item group theme-button">
      <button 
        @click="toggleTheme"
          class="workspace-icon theme-icon premium-control-button"
        :title="isLightTheme ? t('sidebar.theme.dark') : t('sidebar.theme.light')"
      >
          <div class="icon-container">
            <svg v-if="isLightTheme" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>
        </svg>
            <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
        </svg>
          </div>
          <div class="button-glow"></div>
      </button>
      </div>
    </div>

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- Botão de perfil/usuário -->
    <div class="sidebar-item group user-button">
      <button 
        @click="toggleUserMenu"
        class="user-profile-button"
        :class="{ 'active': showUserMenu }"
      >
        <!-- Container da foto com efeitos visuais -->
        <div class="user-avatar-container">
        <img
            v-if="authStore.user?.fotoPerfil && authStore.user.fotoPerfil.trim() !== ''"
          :src="profileImageUrl"
          :alt="authStore.user?.nomeCompleto"
            class="user-avatar-image"
            @error="handleImageError"
            @load="console.log('✅ Imagem do perfil carregada:', profileImageUrl)"
        />
        <div
          v-else
            class="user-avatar-fallback"
        >
          {{ authStore.user?.nomeCompleto?.charAt(0) }}
          </div>
          
          <!-- Indicador de status online -->
          <div class="user-status-indicator"></div>
          
          <!-- Efeito de hover -->
          <div class="user-avatar-overlay"></div>
        </div>
      </button>
      
      <!-- Menu do usuário melhorado -->
      <Teleport to="body">
      <div 
        v-if="showUserMenu"
          class="user-menu-enhanced"
        >
        <!-- Header do menu com foto grande -->
        <div class="user-menu-header">
          <div class="user-menu-avatar">
            <img
              v-if="authStore.user?.fotoPerfil && authStore.user.fotoPerfil.trim() !== ''"
              :src="profileImageUrl"
              :alt="authStore.user?.nomeCompleto"
              class="user-menu-avatar-image"
              @error="handleImageError"
              @load="console.log('✅ Imagem do perfil no menu carregada:', profileImageUrl)"
            />
            <div
              v-else
              class="user-menu-avatar-fallback"
            >
              {{ authStore.user?.nomeCompleto?.charAt(0) }}
        </div>
            <div class="user-menu-status"></div>
          </div>
          
          <div class="user-menu-info">
            <h3 class="user-menu-name">{{ authStore.user?.nomeCompleto }}</h3>
            <p class="user-menu-email">{{ authStore.user?.email }}</p>
            <div class="user-menu-badge">
              <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span>{{ t('sidebar.userMenu.verified') }}</span>
            </div>
          </div>
        </div>
        
        <!-- Divisor -->
        <div class="user-menu-divider"></div>
        
        <!-- Opções do menu -->
        <div class="user-menu-options">
          <button
            @click="goToProfile"
            class="user-menu-option profile-option group"
          >
            <div class="option-icon">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div class="option-content">
              <span class="option-title">{{ t('sidebar.userMenu.profileTitle') }}</span>
              <span class="option-subtitle">{{ t('sidebar.userMenu.profileSubtitle') }}</span>
            </div>
            <div class="option-arrow">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </div>
          </button>
          
        <button
          @click="handleLogout"
            class="user-menu-option logout-option group"
          >
            <div class="option-icon logout-icon">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
              </svg>
            </div>
            <div class="option-content">
              <span class="option-title">{{ t('sidebar.userMenu.logoutTitle') }}</span>
              <span class="option-subtitle">{{ t('sidebar.userMenu.logoutSubtitle') }}</span>
            </div>
            <div class="option-arrow">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </div>
        </button>
      </div>
      </div>
      </Teleport>
    </div>

    <!-- Card de informações do workspace - Renderizado fora da sidebar -->
    <Teleport to="body">
    <div 
      v-if="showInfoCard && hoveredWorkspace"
      class="workspace-info-card"
      :style="infoCardPosition"
    >
      <div class="premium-panel-mesh" aria-hidden="true" />
      <div class="premium-panel-glow" aria-hidden="true" />
      <div class="info-header premium-panel-header">
        <div class="info-header-background"></div>
        <div class="info-icon-container">
        <div 
          class="info-icon"
          :style="{ backgroundColor: hoveredWorkspace.corWorkspace || '#5865F2' }"
        >
          <!-- Exibir foto se disponível, senão exibir primeira letra -->
          <img 
            v-if="hoveredWorkspace.fotoWorkspace && hoveredWorkspace.fotoWorkspace.trim() !== ''" 
            :src="workspaceMediaSrc(hoveredWorkspace.fotoWorkspace)"
            :alt="hoveredWorkspace.nome"
              class="info-workspace-image"
            @error="handleImageError"
          />
            <span v-else class="info-workspace-initial">{{ hoveredWorkspace.nome.charAt(0).toUpperCase() }}</span>
          </div>
          <div class="info-status-badge">
            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span>{{ t('sidebar.infoCard.active') }}</span>
          </div>
        </div>
        <div class="info-details">
          <h3 class="info-title">{{ hoveredWorkspace.nome }}</h3>
          <p class="info-type">{{ workspaceTypeLabel(hoveredWorkspace.tipo) }}</p>
        </div>
      </div>

      <!-- Conteúdo principal -->
      <div class="info-content info-actions">
        <div class="info-description-section">
          <h4 class="info-section-title">{{ t('sidebar.infoCard.description') }}</h4>
          <p class="info-description">{{ hoveredWorkspace.descricao || t('sidebar.infoCard.noDescription') }}</p>
        </div>
        
        <div class="info-divider"></div>
        
        <div class="info-stats-section">
          <h4 class="info-section-title">{{ t('sidebar.infoCard.information') }}</h4>
        <div class="info-stats">
            <div class="stat-item">
              <div class="stat-icon">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
        </div>
              <div class="stat-content">
                <span class="stat-label">{{ t('sidebar.infoCard.createdAt') }}</span>
                <span class="stat-value">{{ formatDate(hoveredWorkspace.dataCriacao) }}</span>
      </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <div class="stat-content">
                <span class="stat-label">{{ t('sidebar.infoCard.status') }}</span>
                <span class="stat-value">{{ t('sidebar.infoCard.statusActive') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </Teleport>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted, h, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useWorkspaceStore } from '../stores/workspace'
import { useThemeStore } from '../stores/theme'
import { workspaceOrdenacaoService } from '../services/workspaceOrdenacao'
import { useToast } from 'vue-toastification'
import { resolveMediaUrl } from '@/config/app'
import { useSortable } from '@vueuse/integrations/useSortable'
import Sortable from 'sortablejs'
import { useI18n } from 'vue-i18n'
import { intlLocaleFor } from '../utils/format'
import { useGlobalWorkspaces } from '../composables/useGlobalWorkspaces'
import { isSuperAdminPreview, clearSuperAdminPreview } from '../composables/useSuperAdminWorkspacePreview'

// Ícones SVG como componentes
const TaskIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
      })
    ])
  }
}

const UsersIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
      })
    ])
  }
}

const FolderIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z'
      })
    ])
  }
}

const BriefcaseIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6'
      })
    ])
  }
}

const ChartIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
      })
    ])
  }
}

const LightbulbIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
      })
    ])
  }
}

const HeartIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z'
      })
    ])
  }
}

const StarIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z'
      })
    ])
  }
}

const RocketIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M13 10V3L4 14h7v7l9-11h-7z'
      })
    ])
  }
}

const ShieldIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
      })
    ])
  }
}

const CogIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
      }),
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z'
      })
    ])
  }
}

const LetterIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M4 6h16M4 12h16M4 18h16'
      })
    ])
  }
}

const HomeIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
      })
    ])
  }
}

const CalendarIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
      })
    ])
  }
}

const MailIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
      })
    ])
  }
}

const PhoneIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
      })
    ])
  }
}

const GlobeIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9'
      })
    ])
  }
}

const BookIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
      })
    ])
  }
}

const MusicIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3'
      })
    ])
  }
}

const CameraIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z'
      }),
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M15 13a3 3 0 11-6 0 3 3 0 016 0z'
      })
    ])
  }
}

const GiftIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7'
      })
    ])
  }
}

const GamepadIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z'
      }),
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      })
    ])
  }
}

const CodeIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4' })
    ])
  }
}

const DatabaseIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4' })
    ])
  }
}

const CloudIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z' })
    ])
  }
}

const ServerIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01' })
    ])
  }
}

const ShoppingCartIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z' })
    ])
  }
}

const TruckIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0' })
    ])
  }
}

const MegaphoneIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z' })
    ])
  }
}

const BeakerIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z' })
    ])
  }
}

const CurrencyIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' })
    ])
  }
}

const DocumentIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' })
    ])
  }
}

const ClipboardIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' })
    ])
  }
}

const FlagIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9' })
    ])
  }
}

const BellIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' })
    ])
  }
}

const ChatIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' })
    ])
  }
}

const VideoIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' })
    ])
  }
}

const ImageIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z' })
    ])
  }
}

const PaperclipIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13' })
    ])
  }
}

const KeyIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' })
    ])
  }
}

const LockIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z' })
    ])
  }
}

const PuzzleIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z' })
    ])
  }
}

const TrendingUpIcon = {
  render() {
    return h('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', class: 'w-6 h-6' }, [
      h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' })
    ])
  }
}

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const workspaceStore = useWorkspaceStore()
const themeStore = useThemeStore()
const toast = useToast()
const { t, locale } = useI18n()
const { removeWorkspaceFromList, goHome: navigateHomeGlobal } = useGlobalWorkspaces()

const workspaceTypeLabel = (tipo) => {
  if (tipo === 'CRM') return t('dashboard.workspaceType.crm')
  if (tipo === 'TAREFAS' || tipo === 'TASK') return t('dashboard.workspaceType.task')
  return tipo || t('dashboard.workspaceType.task')
}

// Props
const props = defineProps({
  workspaces: {
    type: Array,
    default: () => []
  },
  currentWorkspace: {
    type: Object,
    default: null
  },
  isHome: {
    type: Boolean,
    default: true
  }
})

// Debug: logar workspaces quando mudarem
watch(() => props.workspaces, (newWorkspaces) => {
  console.log('🔍 WorkspaceSidebar - workspaces recebidos:', newWorkspaces)
  console.log('📊 Total de workspaces na sidebar:', newWorkspaces.length)
  newWorkspaces.forEach(w => {
    if (w.fotoWorkspace) {
      console.log(`🖼️ Workspace ${w.id} tem foto: ${w.fotoWorkspace}`)
    }
  })
}, { immediate: true })

// Emits
const emit = defineEmits(['select-workspace', 'go-home', 'open-create-modal', 'reorder-workspaces', 'edit-workspace', 'delete-workspace', 'open-profile'])

// Refs
const workspaceList = ref(null)
const showUserMenu = ref(false)
const showInfoCard = ref(false)
const hoveredWorkspace = ref(null)
const infoCardPosition = ref({})
const failedImages = ref(new Set())

// Menu de contexto
const showContextMenuState = ref(false)
const contextMenuWorkspace = ref(null)
const contextMenuPosition = ref({})
const isMobileViewport = ref(false)
const showMobileQuickMenu = ref(false)

// Computed
const isLightTheme = computed(() => themeStore.isLight)
const orderedWorkspaces = computed(() => {
  console.log('🔍 [SIDEBAR] orderedWorkspaces computed executado')
  console.log('📊 [SIDEBAR] Total de workspaces recebidos:', props.workspaces?.length || 0)
  
  if (!props.workspaces || props.workspaces.length === 0) {
    console.log('⚠️ [SIDEBAR] Nenhum workspace recebido!')
    return []
  }
  
  // Carregar ordenação personalizada do localStorage
  const savedOrder = localStorage.getItem(`workspace-order-${authStore.user?.id}`)
  
  if (savedOrder) {
    try {
      const order = JSON.parse(savedOrder)
      console.log('📋 [SIDEBAR] Ordenação salva encontrada:', order.length, 'IDs')
      
      const orderedWorkspaces = order.map(id => props.workspaces.find(w => w.id === id)).filter(Boolean)
      console.log('✅ [SIDEBAR] Workspaces ordenados encontrados:', orderedWorkspaces.length)
      
      // Adicionar workspaces novos que não estão na ordenação salva
      const orderedIds = orderedWorkspaces.map(w => w.id)
      const newWorkspaces = props.workspaces.filter(w => !orderedIds.includes(w.id))
      console.log('🆕 [SIDEBAR] Workspaces novos (não na ordenação):', newWorkspaces.length)
      
      const resultado = [...orderedWorkspaces, ...newWorkspaces]
      console.log('📦 [SIDEBAR] Total FINAL retornado:', resultado.length)
      
      return resultado
    } catch (error) {
      console.error('❌ [SIDEBAR] Erro ao carregar ordenação:', error)
      console.log('🔄 [SIDEBAR] Retornando workspaces sem ordenação')
      return props.workspaces
    }
  }
  
  console.log('📦 [SIDEBAR] Retornando todos os workspaces (sem ordenação salva):', props.workspaces.length)
  return props.workspaces
})

// Métodos
const selectWorkspace = (workspace) => {
  // Não selecionar se estiver arrastando
  if (isDragging.value) {
    console.log('🔄 Ignorando clique durante drag')
    return
  }
  // Fechar informações do workspace quando selecionar
  showInfoCard.value = false
  hoveredWorkspace.value = null
  emit('select-workspace', workspace)
}

const goHome = () => {
  emit('go-home')
}

const openCreateModal = () => {
  emit('open-create-modal')
}

const updateMobileViewport = () => {
  if (typeof window === 'undefined') return
  isMobileViewport.value = window.matchMedia('(max-width: 768px)').matches
  if (!isMobileViewport.value) {
    showMobileQuickMenu.value = false
  }
}

const openMobileQuickMenu = () => {
  showMobileQuickMenu.value = true
}

const closeMobileQuickMenu = () => {
  showMobileQuickMenu.value = false
}

const selectWorkspaceMobile = (workspace) => {
  selectWorkspace(workspace)
  closeMobileQuickMenu()
}

const goHomeMobile = () => {
  goHome()
  closeMobileQuickMenu()
}

const openCreateModalMobile = () => {
  openCreateModal()
  closeMobileQuickMenu()
}

const toggleThemeMobile = () => {
  toggleTheme()
}

const goToProfileMobile = () => {
  goToProfile()
  closeMobileQuickMenu()
}

const handleLogoutMobile = () => {
  closeMobileQuickMenu()
  handleLogout()
}

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value
}

const toggleTheme = () => {
  themeStore.toggleTheme()
}

const goToProfile = () => {
  showUserMenu.value = false
  emit('open-profile')
}

const handleLogout = async () => {
  showUserMenu.value = false
  await authStore.logout()
  await router.replace('/login')
}

const showWorkspaceInfo = (workspace, event) => {
  // Não mostrar informações durante o drag
  if (isDragging.value) {
    return
  }
  
  hoveredWorkspace.value = workspace
  showInfoCard.value = true
  
  // Calcular posição do card
  const rect = event.target.getBoundingClientRect()
  infoCardPosition.value = {
    left: `${rect.right + 10}px`,
    top: `${rect.top}px`,
    '--panel-accent': workspace.corWorkspace || '#6366f1'
  }
}

const hideWorkspaceInfo = () => {
  showInfoCard.value = false
  hoveredWorkspace.value = null
}

// Função para ajustar a luminosidade de uma cor
const adjustColorLightness = (hex, percent) => {
  // Remove o # se presente
  hex = hex.replace('#', '')
  
  // Garante que seja um hex válido
  if (hex.length !== 6) {
    return hex // Retorna a cor original se não for válida
  }
  
  // Converte para RGB
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)
  
  // Ajusta a luminosidade (percent > 0 = mais claro, percent < 0 = mais escuro)
  const factor = percent / 100
  const newR = Math.min(255, Math.max(0, Math.round(r + (255 - r) * factor)))
  const newG = Math.min(255, Math.max(0, Math.round(g + (255 - g) * factor)))
  const newB = Math.min(255, Math.max(0, Math.round(b + (255 - b) * factor)))
  
  // Converte de volta para hex
  const toHex = (n) => {
    const hex = n.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }
  
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`
}

// Menu de contexto
const showContextMenu = (workspace, event) => {
  contextMenuWorkspace.value = workspace
  showContextMenuState.value = true
  
  // Calcular posição do menu ao lado do workspace
  const rect = event.target.getBoundingClientRect()
  const menuWidth = 420 // Largura do menu
  const menuHeight = 250 // Altura aproximada do menu
  const sidebarWidth = 80 // Largura da sidebar
  
  // Calcular posição ideal - sempre à direita da sidebar
  let left = sidebarWidth + 20 // 20px de margem da sidebar
  let top = rect.top // Alinhar com o topo do workspace clicado
  
  // Debug: verificar se o rect está correto
  console.log('🔍 Rect do workspace:', {
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    height: rect.height
  })
  
  // Verificar se o menu cabe à direita
  const viewportWidth = window.innerWidth
  if (left + menuWidth > viewportWidth - 20) {
    // Se não cabe à direita, colocar à esquerda da sidebar
    left = 20
  }
  
  // Verificar se o menu cabe verticalmente
  const viewportHeight = window.innerHeight
  if (top + menuHeight > viewportHeight - 20) {
    // Ajustar para cima se necessário
    top = viewportHeight - menuHeight - 20
  }
  
  // Garantir que não saia da tela
  left = Math.max(20, Math.min(left, viewportWidth - menuWidth - 20))
  top = Math.max(20, Math.min(top, viewportHeight - menuHeight - 20))
  
  contextMenuPosition.value = {
    left: `${left}px`,
    top: `${top}px`,
    '--panel-accent': workspace.corWorkspace || '#6366f1'
  }
  
  // Debug: log da posição calculada
  console.log('🎯 Menu de contexto posicionado:', {
    workspace: workspace.nome,
    rect: { top: rect.top, left: rect.left, right: rect.right, bottom: rect.bottom },
    menuPosition: { left, top },
    viewport: { width: viewportWidth, height: viewportHeight },
    sidebarWidth: sidebarWidth,
    menuWidth: menuWidth,
    menuHeight: menuHeight,
    finalPosition: contextMenuPosition.value
  })
  
  // Fechar informações do workspace quando abrir menu de contexto
  showInfoCard.value = false
}

const hideContextMenu = () => {
  showContextMenuState.value = false
  contextMenuWorkspace.value = null
}

const editWorkspace = (workspace) => {
  hideContextMenu()
  emit('edit-workspace', workspace)
}

const deleteWorkspace = (workspace) => {
  hideContextMenu()
  emit('delete-workspace', workspace)
}

const isPreviewSidebarWorkspace = (workspace) => {
  if (!workspace?.id) return false
  if (isSuperAdminPreview(workspace.id)) return true
  if (!authStore.isSuperAdmin) return false
  const uid = Number(authStore.user?.id)
  if (!uid) return false
  const criadorId = workspace.criadorId ?? workspace.criador?.id
  return criadorId != null && Number(criadorId) !== uid
}

const removeFromSidebar = (workspace) => {
  hideContextMenu()
  if (!workspace?.id) return
  removeWorkspaceFromList(workspace.id)
  clearSuperAdminPreview(workspace.id)
  if (props.currentWorkspace?.id === workspace.id) {
    navigateHomeGlobal()
  }
  toast.success(t('sidebar.contextMenu.removeFromSidebarSuccess'))
}

const formatDate = (dateString) => {
  if (!dateString) return t('sidebar.dateUnavailable')
  const date = new Date(dateString)
  return date.toLocaleDateString(intlLocaleFor(locale.value))
}

// Função para obter o componente de ícone correto
const getIconComponent = (iconName) => {
  const iconMap = {
    'task': TaskIcon,
    'users': UsersIcon,
    'folder': FolderIcon,
    'briefcase': BriefcaseIcon,
    'chart': ChartIcon,
    'lightbulb': LightbulbIcon,
    'heart': HeartIcon,
    'star': StarIcon,
    'rocket': RocketIcon,
    'shield': ShieldIcon,
    'cog': CogIcon,
    'letter': LetterIcon,
    'home': HomeIcon,
    'calendar': CalendarIcon,
    'mail': MailIcon,
    'phone': PhoneIcon,
    'globe': GlobeIcon,
    'book': BookIcon,
    'music': MusicIcon,
    'camera': CameraIcon,
    'gift': GiftIcon,
    'gamepad': GamepadIcon,
    'code': CodeIcon,
    'database': DatabaseIcon,
    'cloud': CloudIcon,
    'server': ServerIcon,
    'shopping-cart': ShoppingCartIcon,
    'truck': TruckIcon,
    'megaphone': MegaphoneIcon,
    'beaker': BeakerIcon,
    'currency': CurrencyIcon,
    'document': DocumentIcon,
    'clipboard': ClipboardIcon,
    'flag': FlagIcon,
    'bell': BellIcon,
    'chat': ChatIcon,
    'video': VideoIcon,
    'image': ImageIcon,
    'paperclip': PaperclipIcon,
    'key': KeyIcon,
    'lock': LockIcon,
    'puzzle': PuzzleIcon,
    'trending-up': TrendingUpIcon
  }
  
  return iconMap[iconName] || LetterIcon
}

// Função para tratar erro de carregamento de imagem (workspace e perfil)
const handleImageError = (event) => {
  console.warn('Erro ao carregar imagem:', event.target.src)
  // Marcar a imagem como falhada para mostrar o ícone
  const workspaceId = event.target.closest('.workspace-item')?.dataset?.id
  if (workspaceId) {
    failedImages.value.add(parseInt(workspaceId))
  }
}

// Variável para armazenar a lista ordenada
const sortedWorkspaces = ref([])

// Variável para controlar estado de drag
const isDragging = ref(false)

const workspaceMediaSrc = (url) => {
  const resolved = resolveMediaUrl(url)
  if (!resolved) return ''
  return `${resolved}?t=${Date.now()}`
}

// Computed para URL da imagem do perfil com timestamp
const profileImageUrl = computed(() => {
  if (authStore.user?.fotoPerfil) {
    const resolved = resolveMediaUrl(authStore.user.fotoPerfil)
    if (!resolved) return ''
    return `${resolved}?t=${Date.now()}`
  }
  return ''
})

// Inicializar Sortable.js
let sortableInstance = null

const initializeSortable = () => {
  if (!workspaceList.value || sortableInstance) return
  
  sortableInstance = new Sortable(workspaceList.value, {
    animation: 250,
    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    forceFallback: true,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: true,
    swapThreshold: 0.65,
    invertSwap: true,
    direction: 'vertical',
    scroll: true,
    scrollSensitivity: 30,
    scrollSpeed: 20,
    
    onStart: (evt) => {
      console.log('🔄 Sortable start:', evt.oldIndex)
      // Marcar como arrastando
      isDragging.value = true
      // Adicionar classe de animação suave
      evt.item.classList.add('sortable-dragging')
      // Fechar informações do workspace durante o drag
      showInfoCard.value = false
      hoveredWorkspace.value = null
    },
    
    onMove: (evt) => {
      // Adicionar feedback visual durante o movimento
      const relatedElement = evt.related
      if (relatedElement) {
        relatedElement.classList.add('sortable-swap-highlight')
      }
    },
    
    onUpdate: (evt) => {
      // Limpar classes de highlight
      document.querySelectorAll('.sortable-swap-highlight').forEach(el => {
        el.classList.remove('sortable-swap-highlight')
      })
    },
    
    onEnd: async (evt) => {
      console.log('🔄 Sortable end:', { oldIndex: evt.oldIndex, newIndex: evt.newIndex })

      try {
        if (evt.oldIndex === evt.newIndex) {
          console.log('🔁 Drag cancelado (mesma posição)')
          return
        }

        // Criar nova ordem baseada nos IDs dos elementos
        const newOrder = []
        const elements = workspaceList.value.querySelectorAll('.workspace-item')
        
        elements.forEach(element => {
          const workspaceId = parseInt(element.dataset.id)
          const workspace = orderedWorkspaces.value.find(w => w.id === workspaceId)
          if (workspace) {
            newOrder.push(workspace)
          }
        })
        
        console.log('📝 Nova ordem:', newOrder.map(w => ({ id: w.id, nome: w.nome })))
        
        // Salvar nova ordenação na API (TODOS os workspaces com acesso)
        const orderIds = newOrder.map(w => w.id)
        await workspaceOrdenacaoService.salvarOrdenacao(authStore.user.id, orderIds)
        
        // Salvar também no localStorage como backup
        localStorage.setItem(`workspace-order-${authStore.user?.id}`, JSON.stringify(orderIds))
        
        // Emitir evento para atualizar a lista
        emit('reorder-workspaces', newOrder)
        
        toast.success('Workspaces reordenados com sucesso!')
        
      } catch (error) {
        console.error('Erro ao salvar ordenação:', error)
        toast.error('Erro ao salvar ordenação dos workspaces')
        
        // Reverter a ordem em caso de erro
        if (sortableInstance) {
          sortableInstance.sort(orderedWorkspaces.value.map(w => w.id.toString()))
        }
      } finally {
        // Limpar todas as classes de animação
        evt.item.classList.remove('sortable-dragging')
        document.querySelectorAll('.sortable-swap-highlight').forEach(el => {
          el.classList.remove('sortable-swap-highlight')
        })
        // Marcar como não arrastando
        isDragging.value = false
      }
    }
  })
}

// Fechar menus ao clicar fora
const handleClickOutside = (event) => {
  if (!event.target.closest('.user-button')) {
    showUserMenu.value = false
  }
  if (!event.target.closest('.context-menu')) {
    hideContextMenu()
  }
}

// Carregar ordenação da API
const carregarOrdenacaoDaAPI = async () => {
  if (!authStore.user?.id) return
  
  try {
    console.log('🔄 Carregando ordenação da API para usuário:', authStore.user.id)
    
    const ordenacao = await workspaceOrdenacaoService.getOrdenacao(authStore.user.id)
    
    if (ordenacao && ordenacao.length > 0) {
      // Converter para formato esperado pelo componente
      const orderIds = ordenacao.map(item => item.workspaceId)
      localStorage.setItem(`workspace-order-${authStore.user.id}`, JSON.stringify(orderIds))
      console.log('✅ Ordenação carregada da API:', orderIds)
    } else {
      console.log('ℹ️ Usuário não tem ordenação personalizada, usando padrão')
    }
  } catch (error) {
    console.error('❌ Erro ao carregar ordenação da API:', error)
    // Em caso de erro, manter ordenação do localStorage se existir
  }
}

// Lifecycle
onMounted(async () => {
  updateMobileViewport()
  window.addEventListener('resize', updateMobileViewport)
  document.addEventListener('click', handleClickOutside)
  
  // Carregar ordenação da API quando componente for montado
  await carregarOrdenacaoDaAPI()
  
  // Aguardar o próximo tick para garantir que o DOM está renderizado
  await nextTick()
  
  // Inicializar Sortable.js
  initializeSortable()
})

// Watcher para debug
watch(() => authStore.user, (newUser) => {
  console.log('👤 Usuário mudou na sidebar:', newUser)
  console.log('📸 Foto do perfil:', newUser?.fotoPerfil)
}, { deep: true })

onUnmounted(() => {
  window.removeEventListener('resize', updateMobileViewport)
  document.removeEventListener('click', handleClickOutside)
  
  // Destruir instância do Sortable
  if (sortableInstance) {
    sortableInstance.destroy()
    sortableInstance = null
  }
})

watch(
  () => route.path,
  () => {
    closeMobileQuickMenu()
  }
)
</script>

<style scoped>
/* ===== SIDEBAR PREMIUM - DESIGN ABSOLUTAMENTE LINDO ===== */

.mobile-sidebar-fab,
.mobile-sidebar-modal {
  display: none;
}

@media (max-width: 768px) {
  .workspace-sidebar {
    display: none !important;
  }

  .mobile-sidebar-fab {
    position: fixed;
    right: 14px;
    bottom: 14px;
    width: 42px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid var(--border-primary);
    background: var(--bg-secondary);
    color: var(--text-primary);
    z-index: 98;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  }

  .mobile-sidebar-modal {
    position: fixed;
    inset: 0;
    z-index: 120;
    display: block;
  }

  .mobile-sidebar-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .mobile-sidebar-sheet {
    position: absolute;
    left: 8px;
    right: 8px;
    top: 56px;
    bottom: 8px;
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    border-radius: 4px;
    padding: 12px;
    overflow-y: auto;
  }

  .mobile-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .mobile-sheet-header h3 {
    margin: 0;
    font-size: 16px;
    color: var(--text-primary);
  }

  .mobile-sheet-close {
    border: 1px solid var(--border-primary);
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 12px;
  }

  .mobile-actions-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 12px;
  }

  .mobile-action-tile {
    border: 1px solid var(--border-primary);
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-radius: 4px;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .mobile-action-tile.danger {
    color: #ef4444;
  }

  .tile-icon {
    font-size: 18px;
    line-height: 1;
  }

  .tile-label {
    font-size: 11px;
    font-weight: 600;
    text-align: center;
  }

  .mobile-workspaces-title {
    font-size: 12px;
    font-weight: 700;
    color: var(--text-secondary);
    margin: 4px 0 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .mobile-workspaces-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .mobile-workspace-item {
    position: relative;
    border: 1px solid color-mix(in srgb, var(--mobile-ws-color, #5865F2) 34%, var(--border-primary));
    background:
      linear-gradient(180deg,
        color-mix(in srgb, var(--mobile-ws-color, #5865F2) 14%, transparent) 0%,
        color-mix(in srgb, var(--mobile-ws-color-light, #7d89ff) 7%, transparent) 100%
      ),
      var(--bg-secondary);
    border-radius: 4px;
    padding: 9px 6px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    color: var(--text-primary);
    box-shadow: 0 5px 14px rgba(15, 23, 42, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }

  .mobile-workspace-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 3px;
    border-radius: 4px 4px 0 0;
    background: linear-gradient(90deg, var(--mobile-ws-color, #5865F2), var(--mobile-ws-color-light, #7d89ff));
    opacity: 0.95;
  }

  .mobile-workspace-item.active {
    border-color: var(--mobile-ws-color, #5865F2);
    box-shadow:
      0 0 0 1px color-mix(in srgb, var(--mobile-ws-color, #5865F2) 50%, transparent) inset,
      0 8px 18px color-mix(in srgb, var(--mobile-ws-color, #5865F2) 24%, transparent);
    transform: translateY(-1px);
  }

  .mobile-workspace-avatar {
    width: 38px;
    height: 38px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-tertiary);
    border: 1px solid color-mix(in srgb, var(--mobile-ws-color, #5865F2) 32%, transparent);
    box-shadow: 0 3px 10px color-mix(in srgb, var(--mobile-ws-color, #5865F2) 24%, transparent);
  }

  .mobile-workspace-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mobile-workspace-icon {
    width: 18px;
    height: 18px;
  }

  .mobile-workspace-name {
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.1px;
  }

  .mobile-workspace-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
  }
}

/* Garantir que todos os elementos da sidebar tenham z-index alto */
.workspace-sidebar * {
  position: relative;
  z-index: inherit;
}

/* Forçar menus para o topo absoluto da pilha */
.context-menu,
.user-menu-enhanced,
.workspace-info-card {
  position: fixed !important;
  z-index: 99999999 !important;
  isolation: isolate !important;
  transform: translateZ(0) !important;
  pointer-events: auto !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Exceções para elementos que precisam de position fixed */
.workspace-sidebar .context-menu,
.workspace-sidebar .user-menu-enhanced,
.workspace-sidebar .workspace-info-card {
  position: fixed !important;
  z-index: 99999999 !important;
  isolation: isolate !important;
  transform: translateZ(0) !important;
}
.workspace-sidebar {
  @apply w-20 flex flex-col h-screen relative;
  background-color: var(--bg-secondary);
  border-right: 1px solid var(--border-primary);
  backdrop-filter: blur(25px) saturate(1.2);
  position: relative;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 
    4px 0 25px rgba(0, 0, 0, 0.25),
    inset -1px 0 0 rgba(0, 0, 0, 0.06);
  overflow-y: auto !important;
  overflow-x: hidden !important;
  z-index: 1000;
  
  /* Barra de rolagem discreta e elegante */
  scrollbar-width: thin;
  scrollbar-color: var(--border-secondary) transparent;
}

/* Webkit scrollbar personalizada */
.workspace-sidebar::-webkit-scrollbar {
  width: 4px;
}

.workspace-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.workspace-sidebar::-webkit-scrollbar-thumb {
  background-color: var(--border-secondary);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.workspace-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: var(--border-hover);
}

.workspace-sidebar::-webkit-scrollbar-thumb:active {
  background-color: var(--border-primary);
}

.workspace-sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(ellipse at top, rgba(88, 101, 242, 0.08) 0%, transparent 50%),
    linear-gradient(180deg, 
      rgba(255, 255, 255, 0.02) 0%, 
      transparent 50%, 
      rgba(255, 255, 255, 0.01) 100%
    );
  pointer-events: none;
  z-index: 1;
}

.workspace-sidebar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(180deg, 
    transparent 0%, 
    rgba(88, 101, 242, 0.3) 50%, 
    transparent 100%
  );
  z-index: 2;
}

/* Tema claro premium */
.workspace-sidebar.light-theme { }

.workspace-sidebar.light-theme::before { }

.workspace-sidebar.light-theme::after { }

/* Barra de rolagem para tema claro */
.workspace-sidebar.light-theme { }

.workspace-sidebar.light-theme::-webkit-scrollbar-thumb { }

.workspace-sidebar.light-theme::-webkit-scrollbar-thumb:hover { }

.workspace-sidebar.light-theme::-webkit-scrollbar-thumb:active { }

.sidebar-item {
  @apply relative flex justify-center;
  position: relative;
}

.workspace-icon {
  @apply w-12 h-12 flex items-center justify-center text-white font-bold text-lg overflow-hidden;
  border-radius: 4px;
  transform: scale(1);
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  will-change: transform, border-radius;
  /* Por padrão, fica em preto e branco */
  filter: grayscale(100%) brightness(0.7);
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  min-height: 48px !important;
}

.workspace-icon:hover:not(.active) {
  transform: scale(1.08);
  transition: all 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* Mostra a cor completa no hover */
  filter: grayscale(0%) brightness(1);
}

.workspace-icon:hover.active {
  transform: scale(1.08);
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.18) 0%, 
    rgba(255, 255, 255, 0.12) 50%, 
    rgba(255, 255, 255, 0.18) 100%
  ) !important;
  border: 2px solid var(--workspace-color, rgba(255, 255, 255, 0.25));
  box-shadow: 
    0 12px 40px rgba(0, 0, 0, 0.5),
    0 6px 20px rgba(255, 255, 255, 0.15),
    0 0 0 2px var(--workspace-color, rgba(255, 255, 255, 0.4)),
    inset 0 1px 0 rgba(255, 255, 255, 0.25),
    inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  /* Mantém a cor completa no hover ativo */
  filter: grayscale(0%) brightness(1.15);
}

.workspace-icon.active {
  border-radius: 4px;
  border: 2px solid var(--workspace-color, rgba(255, 255, 255, 0.2));
  transform: scale(1.05);
  position: relative;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.4),
    0 4px 16px rgba(255, 255, 255, 0.1),
    0 0 0 1px var(--workspace-color, rgba(255, 255, 255, 0.3));
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  /* Mostra a cor completa quando ativo */
  filter: grayscale(0%) brightness(1.1);
}

/* Removido o overlay ::before para mostrar apenas as informações do workspace */

.home-icon {
  @apply bg-discord-blurple hover:bg-blue-600;
  /* Mantém a cor original para ícones especiais */
  filter: none !important;
}

.add-icon {
  @apply bg-discord-dark-300 hover:bg-green-500 text-green-500 hover:text-white;
  /* Mantém a cor original para ícones especiais */
  filter: none !important;
}

.user-icon {
  @apply bg-discord-dark-300 hover:bg-discord-dark-200 text-gray-400 hover:text-white;
  /* Mantém a cor original para ícones especiais */
  filter: none !important;
}

.theme-icon {
  @apply bg-discord-dark-300 hover:bg-discord-dark-200 text-gray-400 hover:text-white;
  /* Mantém a cor original para ícones especiais */
  filter: none !important;
}

.active-indicator {
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%) scale(1);
  width: 0;
  height: 0;
  border-left: 8px solid var(--workspace-color, #ffffff);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  filter: 
    drop-shadow(0 4px 12px var(--workspace-color, rgba(255, 255, 255, 0.6)))
    drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));
  animation: arrowPulse 2s ease-in-out infinite alternate;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

@keyframes arrowPulse {
  0% {
    filter: 
      drop-shadow(0 4px 12px var(--workspace-color, rgba(255, 255, 255, 0.4)))
      drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
    transform: translateY(-50%) scale(1);
  }
  50% {
    filter: 
      drop-shadow(0 6px 16px var(--workspace-color, rgba(255, 255, 255, 0.7)))
      drop-shadow(0 3px 8px rgba(0, 0, 0, 0.4));
    transform: translateY(-50%) scale(1.05);
  }
  100% {
    filter: 
      drop-shadow(0 4px 12px var(--workspace-color, rgba(255, 255, 255, 0.4)))
      drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
    transform: translateY(-50%) scale(1);
  }
}

/* CSS dos tooltips removido */

.separator {
  @apply w-8 h-0.5 bg-discord-dark-200 rounded-full;
}

.workspace-list {
  @apply flex flex-col space-y-3;
  position: relative;
}

.workspace-list::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.08) 20%, 
    rgba(255, 255, 255, 0.12) 50%, 
    rgba(255, 255, 255, 0.08) 80%, 
    transparent 100%
  );
}

.workspace-item {
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  will-change: transform, background-color, border-radius;
}

.workspace-item:hover {
  transform: scale(1.02);
  background-color: rgba(114, 118, 125, 0.1);
  border-radius: 4px;
  transition: all 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Estilos do Sortable.js - Estilo Discord */
.sortable-ghost {
  opacity: 0.4;
  background: rgba(114, 118, 125, 0.3);
  border-radius: 4px;
  transform: scale(1);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.sortable-chosen {
  cursor: grabbing !important;
  transform: scale(1);
  transition: all 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 999;
  opacity: 0.6;
  /* Mantém a cor quando selecionado para drag */
  filter: grayscale(0%) brightness(0.9);
}

.sortable-drag {
  opacity: 0.9;
  transform: rotate(2deg) scale(1.05);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  z-index: 1000;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  /* Mantém a cor durante o drag */
  filter: grayscale(0%) brightness(1.1);
}

.sortable-fallback {
  display: none;
}

/* Animação suave para todos os itens durante o drag */
.sortable-swap-highlight {
  background: rgba(88, 101, 242, 0.15) !important;
  border-radius: 4px;
  transform: scale(1);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
}


/* Animação de entrada para novos itens */
.workspace-item {
  animation: fadeInUp 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animação de hover mais suave */
.workspace-item:hover .workspace-icon {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Animação durante o drag */
.sortable-dragging {
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  opacity: 0.6 !important;
}

.sortable-dragging .workspace-icon {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
  opacity: 0.6;
  /* Mantém a cor durante o drag */
  filter: grayscale(0%) brightness(0.9);
}

/* Animação de transição suave entre posições */
.workspace-list > * {
  transition: transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.spacer {
  @apply flex-1;
}

/* ===== HEADER DA SIDEBAR PREMIUM ===== */
.sidebar-header {
  @apply p-4 pb-2 relative z-10;
}

.sidebar-logo {
  @apply flex flex-col items-center space-y-2;
}

.logo-icon {
  @apply w-10 h-10 flex items-center justify-center;
  border-radius: 4px;
  background: linear-gradient(135deg, #5865F2 0%, #4752C4 100%);
  color: white;
  box-shadow: 
    0 4px 12px rgba(88, 101, 242, 0.4),
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.logo-icon:hover {
  transform: scale(1.05);
  box-shadow: 
    0 6px 20px rgba(88, 101, 242, 0.5),
    0 4px 12px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.logo-text {
  @apply text-center;
}

.logo-title {
  @apply text-sm font-bold text-white block;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo-subtitle {
  @apply text-xs text-discord-light-400 block;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ===== SEÇÕES DA SIDEBAR ===== */
.sidebar-section {
  @apply w-full px-4 mb-4 relative z-10;
}

.section-title {
  @apply text-xs font-semibold text-discord-light-500 uppercase tracking-wider mb-3 text-center;
  letter-spacing: 1px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 4px;
}

.section-header {
  @apply flex items-center justify-center mb-3 px-1;
}

/* ===== BOTÃO ADICIONAR WORKSPACE PREMIUM ===== */
.premium-add-btn {
  @apply w-12 h-12 flex items-center justify-center relative overflow-hidden mx-auto;
  border-radius: 4px;
  background: linear-gradient(180deg, 
    rgba(16, 18, 22, 0.98) 0%, 
    rgba(32, 34, 37, 0.95) 30%,
    rgba(44, 47, 51, 0.92) 70%,
    rgba(32, 34, 37, 0.98) 100%
  );
  border: 2px solid rgba(255, 255, 255, 0.08);
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  min-height: 48px !important;
}

.premium-add-btn:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.4),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(88, 101, 242, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.add-icon {
  @apply relative z-10;
  color: rgba(255, 255, 255, 0.4);
  background: transparent !important;
  transition: color 0.3s ease;
}

.premium-add-btn:hover .add-icon {
  color: rgba(255, 255, 255, 0.7);
}

.add-glow {
  @apply absolute inset-0 opacity-0 transition-opacity duration-300;
  border-radius: 4px;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.3) 0%, transparent 70%);
}

.premium-add-btn:hover .add-glow {
  @apply opacity-100;
}

.workspace-count {
  @apply text-xs bg-discord-dark-200 text-discord-light-300 px-2 py-1 rounded-full;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ===== SEPARADORES PREMIUM ===== */
.premium-separator {
  @apply h-px mx-4 my-4 relative;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.1) 20%, 
    rgba(88, 101, 242, 0.3) 50%, 
    rgba(255, 255, 255, 0.1) 80%, 
    transparent 100%
  );
}

.premium-separator::before {
  content: '';
  @apply absolute inset-0;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.05) 50%, 
    transparent 100%
  );
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { transform: translateX(-100%); opacity: 0; }
  50% { transform: translateX(100%); opacity: 1; }
}

/* ===== BOTÕES PREMIUM ===== */
.premium-button {
  @apply w-12 h-12 relative overflow-hidden transition-all duration-300;
  border-radius: 4px;
  background: linear-gradient(135deg, #5865F2 0%, #4752C4 100%);
  border: 2px solid transparent;
  box-shadow: 
    0 4px 12px rgba(88, 101, 242, 0.3),
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.premium-button:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 8px 25px rgba(88, 101, 242, 0.4),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(88, 101, 242, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.premium-button.active {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 
    0 8px 25px rgba(88, 101, 242, 0.5),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 3px rgba(88, 101, 242, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.icon-container {
  @apply relative z-10 flex items-center justify-center;
  color: white;
}

.button-glow {
  @apply absolute inset-0 opacity-0 transition-opacity duration-300;
  border-radius: 4px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
}

.premium-button:hover .button-glow {
  @apply opacity-100;
}

/* ===== BOTÕES DE CONTROLE PREMIUM ===== */
.premium-control-button {
  @apply w-12 h-12 relative overflow-hidden transition-all duration-300 mx-auto;
  border-radius: 4px;
  background: linear-gradient(135deg, #5865F2 0%, #4752C4 100%);
  border: 2px solid transparent;
  box-shadow: 
    0 4px 12px rgba(88, 101, 242, 0.3),
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  min-height: 48px !important;
}

.premium-control-button:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 8px 25px rgba(88, 101, 242, 0.4),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(88, 101, 242, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.theme-button {
  @apply flex justify-center items-center w-full px-1;
}

/* ===== WORKSPACES PREMIUM ===== */
.premium-workspace-list {
  @apply space-y-2 px-1;
}

.premium-workspace-item {
  @apply relative;
}

.premium-workspace-button {
  @apply w-12 h-12 relative overflow-hidden transition-all duration-300;
  border-radius: 4px;
  border: 2px solid transparent;
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.2),
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  min-height: 48px !important;
}

.premium-workspace-button:hover {
  transform: scale(1.08);
  border-color: var(--border-hover);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.3),
    0 4px 12px rgba(0, 0, 0, 0.2),
    0 0 0 2px var(--workspace-color, rgba(88, 101, 242, 0.3)),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.premium-workspace-button.active {
  transform: scale(1.08);
  border-color: var(--info);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.4),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 3px var(--workspace-color, rgba(88, 101, 242, 0.4));
}

/* Estado não selecionado no tema claro */
body.tema_clara .premium-workspace-button:not(.active) {
  background-color: var(--bg-secondary) !important;
  border-color: var(--border-primary) !important;
}

body.tema_clara .premium-workspace-button:not(.active) .premium-workspace-icon {
  color: var(--icon-secondary);
}

body.tema_clara .premium-workspace-button:not(.active) .workspace-overlay {
  background-color: transparent !important;
}

body.tema_clara .premium-workspace-button:not(.active) .premium-workspace-image {
  filter: brightness(1) contrast(1) saturate(1);
}

/* Tema claro: botão ativo com mais destaque */
body.tema_clara .premium-workspace-button.active {
  background-color: var(--bg-card);
  border-color: var(--workspace-color, var(--info)) !important;
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.1),
    0 0 0 3px var(--workspace-color, rgba(88, 101, 242, 0.4));
}

/* Tema claro: ícone do botão de adicionar visível */
body.tema_clara .add-icon { color: var(--icon-secondary) !important; }
body.tema_clara .premium-add-btn:hover .add-icon { color: var(--icon-primary) !important; }

/* Tema claro: ícones brancos em hover/selecionado para máxima legibilidade */
body.tema_clara .premium-workspace-button:hover .premium-workspace-icon,
body.tema_clara .premium-workspace-button.active .premium-workspace-icon {
  color: #ffffff !important;
}

body.tema_clara .premium-workspace-button:hover .workspace-overlay {
  background-color: rgba(0, 0, 0, 0.15) !important;
}
body.tema_clara .premium-workspace-button.active .workspace-overlay {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

/* Tema claro: hover com borda cinza mais escura para melhor contraste */
body.tema_clara .premium-workspace-button:not(.active):hover {
  border-color: #6B7280 !important; /* cinza mais escuro */
}

/* Tema claro: borda e ícone mais suaves no estado inativo */
body.tema_clara .premium-workspace-button:not(.active) .workspace-content {
  box-shadow: none;
}

body.tema_clara .premium-workspace-button:not(.active):hover {
  border-color: var(--border-hover);
}

.workspace-content {
  @apply relative w-full h-full overflow-hidden flex items-center justify-center;
  border-radius: 4px;
}

.premium-workspace-image {
  @apply w-full h-full object-cover;
  border-radius: 4px;
  filter: brightness(0.9) contrast(1.1) saturate(1.1);
  transition: all 0.3s ease;
}

.premium-workspace-button:hover .premium-workspace-image,
.premium-workspace-button.active .premium-workspace-image {
  border-radius: 4px;
}

.premium-workspace-icon {
  @apply w-6 h-6 flex items-center justify-center;
  color: var(--icon-primary);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
  transition: all 0.3s ease;
}

/* Tema claro: ícones claros nos itens inativos */
body.tema_clara .premium-workspace-button:not(.active) .premium-workspace-icon {
  color: var(--icon-primary) !important;
}

/* Tema claro: remover filter dos workspace-icon para mostrar cores completas */
body.tema_clara .workspace-icon {
  filter: none !important;
}

.workspace-overlay {
  @apply absolute inset-0 transition-all duration-300;
  background-color: transparent;
}

.premium-workspace-button:hover .workspace-overlay {
  background-color: rgba(0,0,0,0.2);
}

.workspace-shine {
  @apply absolute inset-0 opacity-0 transition-opacity duration-500;
  background: linear-gradient(135deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.2) 50%, 
    transparent 100%
  );
  transform: translateX(-100%);
}

.premium-workspace-button:hover .workspace-shine {
  @apply opacity-100;
  transform: translateX(100%);
  transition: transform 0.6s ease, opacity 0.3s ease;
}

/* ===== INDICADORES PREMIUM ===== */
.premium-indicator {
  @apply absolute top-1/2 w-1 h-8 rounded-full;
  right: -1rem;
  background: linear-gradient(180deg, #5865F2 0%, #4752C4 100%);
  transform: translateY(-50%);
  box-shadow: 
    0 0 10px rgba(88, 101, 242, 0.6),
    0 0 20px rgba(88, 101, 242, 0.3);
  animation: pulse-indicator 2s ease-in-out infinite;
}

@keyframes pulse-indicator {
  0%, 100% { 
    box-shadow: 
      0 0 10px rgba(88, 101, 242, 0.6),
      0 0 20px rgba(88, 101, 242, 0.3);
  }
  50% { 
    box-shadow: 
      0 0 15px rgba(88, 101, 242, 0.8),
      0 0 30px rgba(88, 101, 242, 0.5);
  }
}

.workspace-indicator {
  background: linear-gradient(180deg, var(--workspace-color, #5865F2) 0%, var(--workspace-color-light, #4752C4) 100%);
  box-shadow: 
    0 0 10px var(--workspace-color, rgba(88, 101, 242, 0.6)),
    0 0 20px var(--workspace-color, rgba(88, 101, 242, 0.3));
}

.workspace-indicator {
  animation: pulse-workspace 2s ease-in-out infinite;
}

@keyframes pulse-workspace {
  0%, 100% { 
    box-shadow: 
      0 0 10px var(--workspace-color, rgba(88, 101, 242, 0.6)),
      0 0 20px var(--workspace-color, rgba(88, 101, 242, 0.3));
  }
  50% { 
    box-shadow: 
      0 0 15px var(--workspace-color, rgba(88, 101, 242, 0.8)),
      0 0 30px var(--workspace-color, rgba(88, 101, 242, 0.5));
  }
}

/* Botão de perfil do usuário */
.user-profile-button {
  @apply relative w-12 h-12 overflow-hidden transition-all duration-300 ease-out;
  border-radius: 4px;
  background: linear-gradient(135deg, #5865F2 0%, #4752C4 100%);
  border: 2px solid transparent;
  box-shadow: 
    0 4px 12px rgba(88, 101, 242, 0.3),
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.user-profile-button:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 8px 25px rgba(88, 101, 242, 0.4),
    0 4px 12px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.user-profile-button.active {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 
    0 8px 25px rgba(88, 101, 242, 0.5),
    0 4px 12px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(255, 255, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

/* Container do avatar */
.user-avatar-container {
  @apply relative w-full h-full overflow-hidden;
  border-radius: 4px;
}

.user-avatar-image {
  @apply w-full h-full object-cover;
  filter: brightness(0.9) contrast(1.1);
  transition: all 0.3s ease;
}

.user-avatar-fallback {
  @apply w-full h-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center text-white font-bold text-lg;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
}

/* Indicador de status online */
.user-status-indicator {
  @apply absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-discord-dark-300;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3);
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0%, 100% { box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3); }
  50% { box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1); }
}

/* Overlay de hover */
.user-avatar-overlay {
  @apply absolute inset-0 bg-black bg-opacity-0 transition-all duration-300;
  border-radius: 4px;
}

.user-profile-button:hover .user-avatar-overlay {
  @apply bg-black bg-opacity-20;
}

/* Menu do usuário melhorado */
.user-menu-enhanced {
  @apply absolute bottom-16 rounded-xl shadow-2xl w-80 overflow-hidden;
  left: 40px !important;
  z-index: 99999999 !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  isolation: isolate !important;
  transform: translateZ(0) !important;
  backdrop-filter: blur(20px);
  background-color: var(--bg-modal);
  border: 1px solid var(--border-primary);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.4),
    0 8px 16px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  animation: slideUp 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header do menu */
.user-menu-header {
  @apply p-6;
  border-bottom: 1px solid var(--border-primary);
}

.user-menu-avatar {
  @apply relative w-16 h-16 mx-auto mb-4 rounded-2xl overflow-hidden;
  border: 3px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 8px 16px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

.user-menu-avatar-image {
  @apply w-full h-full object-cover;
  filter: brightness(0.95) contrast(1.05);
}

.user-menu-avatar-fallback {
  @apply w-full h-full flex items-center justify-center font-bold text-2xl;
  color: var(--icon-primary);
  background: linear-gradient(135deg, var(--info) 0%, #4752C4 100%);
}

.user-menu-status {
  @apply absolute bottom-0 right-0 w-4 h-4 rounded-full border-2;
  background-color: #22c55e;
  border-color: var(--bg-modal);
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.4);
}

.user-menu-info {
  @apply text-center;
}

.user-menu-name {
  @apply text-lg font-bold mb-1;
  color: var(--text-primary);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.user-menu-email {
  @apply text-sm mb-3;
  color: var(--text-secondary);
}

.user-menu-badge {
  @apply inline-flex items-center px-3 py-1 bg-green-500/20 text-green-400 text-xs font-medium rounded-full border border-green-500/30;
}

/* Divisor */
.user-menu-divider {
  @apply h-px mx-4;
  background: linear-gradient(90deg, transparent, var(--border-primary), transparent);
}

/* Opções do menu */
.user-menu-options {
  @apply p-2;
}

.user-menu-option {
  @apply w-full flex items-center p-4 transition-all;
  border-radius: 4px duration-200;
  background: transparent;
}

.user-menu-option:hover {
  background-color: var(--bg-hover);
  transform: translateX(4px);
}

.profile-option:hover {
  border-left: 3px solid var(--info);
}

.logout-option:hover {
  border-left: 3px solid var(--error);
}

.option-icon {
  @apply w-10 h-10 rounded-lg flex items-center justify-center mr-4 transition-all duration-200;
  background: linear-gradient(135deg, var(--info) 0%, #4752C4 100%);
  color: var(--icon-primary);
  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.3);
}

.logout-option .logout-icon {
  background: linear-gradient(135deg, var(--error) 0%, #DC2626 100%) !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.4) !important;
  border: 1px solid rgba(239, 68, 68, 0.3) !important;
}

.user-menu-option:hover .option-icon {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.4);
}

.logout-option:hover .logout-icon {
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.5);
  background: linear-gradient(135deg, #F87171 0%, #EF4444 100%);
  transform: scale(1.1);
}

.logout-option:hover .option-title {
  color: var(--error);
}

.logout-option .option-title {
  color: #EF4444;
}

.option-content {
  @apply flex-1 text-left;
}

.option-title {
  @apply block text-sm font-semibold text-white mb-1;
}

.option-subtitle {
  @apply block text-xs text-discord-light-500;
}

.option-arrow {
  @apply w-6 h-6 text-discord-light-400 opacity-0 transition-all duration-200;
}

.user-menu-option:hover .option-arrow {
  @apply opacity-100;
  transform: translateX(4px);
}

/* Tema claro */
.workspace-sidebar.light-theme .user-menu-enhanced {
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.95) 0%, 
    rgba(248, 250, 252, 0.95) 100%
  );
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 8px 16px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.workspace-sidebar.light-theme .user-menu-header {
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(71, 82, 196, 0.05) 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.workspace-sidebar.light-theme .user-menu-name {
  color: #1F2937;
  text-shadow: none;
}

.workspace-sidebar.light-theme .user-menu-email {
  color: #6B7280;
}

.workspace-sidebar.light-theme .option-title {
  color: #1F2937;
}

.workspace-sidebar.light-theme .option-subtitle {
  color: #6B7280;
}

.workspace-sidebar.light-theme .user-menu-option:hover {
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.05) 0%, 
    rgba(0, 0, 0, 0.02) 100%
  );
}

.workspace-info-card {
  @apply fixed w-96 overflow-hidden;
  border-radius: 4px;
  z-index: 99999999 !important;
  isolation: isolate !important;
  transform: translateZ(0) !important;
  backdrop-filter: blur(20px);
  animation: infoCardSlideIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Header elegante com gradiente */
.info-header {
  @apply relative p-6 pb-4;
  background-color: var(--bg-secondary);
  border-bottom: 1px solid var(--border-primary);
}

.info-header-background {
  @apply absolute inset-0;
  background: radial-gradient(ellipse at top, rgba(88, 101, 242, 0.1) 0%, transparent 70%);
}

.info-icon-container {
  @apply flex items-center justify-between mb-4;
}

.info-icon {
  @apply w-16 h-16 flex items-center justify-center flex-shrink-0 relative;
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);
  border: 2px solid color-mix(in srgb, var(--panel-accent) 35%, var(--border-primary));
}

.info-workspace-image {
  @apply w-full h-full object-cover;
  border-radius: 4px;
  filter: brightness(0.9) contrast(1.1) saturate(1.1);
}

.info-workspace-initial {
  @apply text-2xl font-bold;
  color: var(--text-primary);
  text-shadow: none;
}

.info-status-badge {
  @apply inline-flex items-center gap-2 px-3 py-1 text-xs font-medium rounded-full;
  background-color: rgba(16, 185, 129, 0.12);
  color: #10B981;
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.info-details {
  @apply text-center;
}

.info-title {
  @apply text-xl font-bold mb-1;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-shadow: none;
}

.info-type {
  @apply text-sm font-medium;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Conteúdo principal */
.info-content {
  @apply p-6 pt-4;
}

.info-description-section,
.info-stats-section {
  @apply mb-4;
}

.info-section-title {
  @apply text-sm font-semibold mb-3 uppercase tracking-wide;
  color: var(--text-tertiary);
}

.info-description {
  @apply text-sm leading-relaxed;
  color: var(--text-secondary);
  line-height: 1.6;
}

.info-divider {
  @apply h-px my-4;
  background: var(--border-primary);
}

/* Estatísticas melhoradas */
.info-stats {
  @apply grid grid-cols-1 gap-3;
}

.stat-item {
  @apply flex items-center p-3 transition-all;
  border-radius: 4px duration-200;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  min-height: 60px;
}

.stat-item:hover {
  background-color: var(--bg-hover);
  transform: translateX(2px);
}

.stat-icon {
  @apply w-8 h-8 flex items-center justify-center;
  border-radius: 4px flex-shrink-0 mr-3;
  background: linear-gradient(135deg, var(--info) 0%, #4752C4 100%);
  border: 1px solid rgba(88, 101, 242, 0.3);
  color: var(--icon-primary);
  align-self: flex-start;
  margin-top: 2px;
}

.stat-content {
  @apply flex flex-col flex-1;
  justify-content: center;
}

.stat-label {
  @apply text-xs font-medium mb-1;
  color: var(--text-tertiary);
}

.stat-value {
  @apply text-sm font-semibold;
  color: var(--text-primary);
}

.info-details {
  @apply flex-1;
}

.info-title {
  @apply text-lg font-semibold text-white mb-1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.info-type {
  @apply text-sm text-gray-400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-content {
  @apply space-y-2;
}

.info-description {
  @apply text-sm text-gray-300;
}

.info-stats {
  @apply flex items-center space-x-2;
}

.stat-item {
  @apply flex items-center text-xs text-gray-500;
}

.stat-item svg {
  @apply mr-1;
}

/* Tema claro */
.workspace-sidebar.light-theme .separator {
  @apply bg-gray-300;
}

/* CSS dos tooltips para tema claro removido */

.workspace-sidebar.light-theme .user-menu {
  @apply bg-white;
}

.workspace-sidebar.light-theme .user-info {
  @apply border-gray-200;
}

.workspace-sidebar.light-theme .user-name {
  @apply text-gray-800;
}

.workspace-sidebar.light-theme .user-email {
  @apply text-gray-500;
}

.workspace-sidebar.light-theme .logout-button {
  @apply text-gray-500 hover:text-gray-800 hover:bg-gray-100;
}


/* Painéis flutuantes — padrão dashboard-hero (sombras contidas no painel) */
.premium-context-menu,
.workspace-info-card {
  --panel-accent: var(--hero-accent, #6366f1);
  border-radius: 4px !important;
  border: 1px solid color-mix(in srgb, var(--panel-accent) 28%, var(--border-primary)) !important;
  background:
    radial-gradient(ellipse 90% 70% at 0% 0%, color-mix(in srgb, var(--panel-accent) 18%, transparent), transparent 55%),
    radial-gradient(ellipse 70% 60% at 100% 100%, color-mix(in srgb, #8b5cf6 10%, transparent), transparent 50%),
    linear-gradient(165deg, var(--bg-secondary) 0%, var(--bg-primary) 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06) !important;
  overflow: hidden !important;
  contain: paint;
  isolation: isolate;
}

.premium-panel-mesh {
  position: absolute;
  inset: 0;
  opacity: 0.5;
  z-index: 0;
  pointer-events: none;
  background-image:
    linear-gradient(color-mix(in srgb, var(--border-primary) 35%, transparent) 1px, transparent 1px),
    linear-gradient(90deg, color-mix(in srgb, var(--border-primary) 35%, transparent) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 40%, black 20%, transparent 75%);
}

.premium-panel-glow {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(
    ellipse 80% 70% at 100% 0%,
    color-mix(in srgb, var(--panel-accent) 20%, transparent),
    transparent 70%
  );
}

.premium-panel-header {
  position: relative;
  z-index: 2;
  overflow: hidden;
  background: transparent !important;
  border-bottom: 1px solid color-mix(in srgb, var(--panel-accent) 22%, var(--border-primary)) !important;
}

.context-workspace-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--panel-accent) 75%, var(--text-secondary));
}

.context-workspace-eyebrow-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--panel-accent), #8b5cf6);
}

.context-workspace-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.context-workspace-chip {
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  background: color-mix(in srgb, var(--bg-primary) 88%, transparent);
  border: 1px solid var(--border-primary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.context-workspace-chip--accent {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  border-color: transparent;
  background: linear-gradient(135deg, var(--panel-accent), color-mix(in srgb, var(--panel-accent) 70%, #7c3aed));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.context-workspace-name {
  color: color-mix(in srgb, var(--panel-accent) 88%, var(--text-primary)) !important;
}

/* Menu de Contexto */
.context-menu,
.premium-context-menu {
  @apply fixed w-80;
  position: fixed !important;
  border-radius: 4px;
  z-index: 99999999 !important;
  backdrop-filter: blur(20px);
  overflow: hidden !important;
  transform: translateY(-4px) translateZ(0);
  animation: contextMenuSlideIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  pointer-events: auto !important;
  padding-top: 0;
}

@keyframes contextMenuSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(-4px) scale(1);
  }
}

/* Garantir que o menu de contexto seja sempre visível */
.context-menu {
  position: fixed !important;
  z-index: 999999 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.context-menu::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
}

.context-menu > *:not(.premium-panel-mesh):not(.premium-panel-glow) {
  position: relative;
  z-index: 2;
}

.context-menu-header {
  @apply p-5 pb-4 relative;
  background: transparent !important;
  border-bottom: 1px solid var(--border-primary);
}

.context-workspace-info {
  @apply text-center;
}

.context-workspace-icon {
  @apply w-16 h-16 mx-auto mb-4 overflow-hidden flex items-center justify-center flex-shrink-0 relative;
  border-radius: 4px;
  background: linear-gradient(135deg, var(--info) 0%, #4752C4 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);
  border: 2px solid color-mix(in srgb, var(--panel-accent) 35%, var(--border-primary));
}

.context-workspace-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.15) 0%, 
    transparent 70%
  );
  border-radius: 4px;
  pointer-events: none;
}

.context-workspace-image {
  @apply w-full h-full object-cover;
}

.context-workspace-icon-svg {
  @apply w-6 h-6;
  color: var(--icon-primary);
}


.context-workspace-name {
  @apply text-lg font-bold mb-1 text-center;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-shadow: none;
}

.context-workspace-type {
  @apply text-sm font-medium mb-3 text-center;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.context-workspace-badge {
  @apply inline-flex items-center gap-2 px-3 py-1 bg-green-500/20 text-green-400 text-xs font-medium rounded-full mx-auto;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.context-menu-divider {
  @apply mx-2 my-1 relative;
  height: 1px;
  background: var(--border-primary);
}

.context-menu-options {
  @apply p-2;
}

.context-menu-option {
  @apply w-full flex items-center p-4 transition-all;
  border-radius: 4px duration-200;
  background: transparent;
}

.context-menu-option:hover {
  background-color: var(--bg-hover);
  transform: translateX(4px);
}

/* Área de ações do card info (parte inferior) */
.info-actions {
  background-color: var(--bg-card);
  border-top: 1px solid var(--border-primary);
}

.edit-option:hover { border-left: 3px solid var(--info); }

.delete-option:hover { border-left: 3px solid var(--error); }

.option-icon {
  @apply w-10 h-10 flex items-center justify-center;
  border-radius: 4px flex-shrink-0 relative mr-3;
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.2) 0%, rgba(71, 82, 196, 0.1) 100%);
  border: 1px solid rgba(88, 101, 242, 0.3);
  transition: all 0.2s ease;
}

.delete-icon {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(220, 38, 38, 0.1) 100%);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.context-menu-option:hover .option-icon {
  transform: scale(1.05);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--info) 35%, transparent);
}

.delete-option:hover .delete-icon {
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--error) 35%, transparent);
}

.option-content {
  @apply flex-1 text-left;
}

.option-title {
  @apply block text-base font-semibold mb-1;
  color: var(--text-primary);
  text-shadow: none;
}

.option-subtitle {
  @apply block text-sm font-medium;
  color: var(--text-secondary);
}

.option-arrow {
  @apply text-gray-400 transition-all duration-200 opacity-0;
  transform: translateX(-4px);
}

.context-menu-option:hover .option-arrow {
  @apply opacity-100;
  transform: translateX(4px);
}


.context-menu-item svg {
  @apply mr-3;
}

/* ========================================
   WORKSPACE SIDEBAR PREMIUM COM TEMAS
   ======================================== */

/* Menu de contexto - Tema Escuro */
body.tema_escura .context-menu {
  background-color: var(--bg-modal);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
}

body.tema_escura .context-menu-item {
  color: var(--text-primary);
}

body.tema_escura .context-menu-item:hover {
  background-color: var(--bg-hover);
}

body.tema_escura .context-menu-item.danger {
  color: var(--error);
}

body.tema_escura .context-menu-item.danger:hover {
  background-color: rgba(239, 68, 68, 0.1);
}

/* Menu de contexto - Tema Claro */
body.tema_clara .context-menu {
  background-color: var(--bg-modal);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
}

body.tema_clara .context-menu-item {
  color: var(--text-primary);
}

body.tema_clara .context-menu-item:hover {
  background-color: var(--bg-hover);
}

body.tema_clara .context-menu-item.danger {
  color: var(--error);
}

body.tema_clara .context-menu-item.danger:hover {
  background-color: rgba(239, 68, 68, 0.1);
}

/* Workspace info card - Tema Escuro */
body.tema_escura .workspace-info-card {
  background-color: var(--bg-modal);
  border: 1px solid var(--border-primary);
}

body.tema_escura .info-title {
  color: var(--text-primary);
}

body.tema_escura .info-type {
  color: var(--text-secondary);
}

body.tema_escura .info-description {
  color: var(--text-tertiary);
}

body.tema_escura .stat-item {
  color: var(--text-muted);
}

/* Workspace info card - Tema Claro */
body.tema_clara .workspace-info-card {
  background-color: var(--bg-modal);
  border: 1px solid var(--border-primary);
}

body.tema_clara .info-title {
  color: var(--text-primary);
}

body.tema_clara .info-type {
  color: var(--text-secondary);
}

body.tema_clara .info-description {
  color: var(--text-tertiary);
}

body.tema_clara .stat-item {
  color: var(--text-muted);
}

/* Botões de ação - Tema Escuro */
body.tema_escura .theme-icon,
body.tema_escura .user-icon {
  background-color: var(--bg-tertiary);
  color: var(--icon-secondary);
  border: 1px solid var(--border-primary);
}

body.tema_escura .theme-icon:hover,
body.tema_escura .user-icon:hover {
  background-color: var(--bg-hover);
  color: var(--icon-primary);
}

/* Botões de ação - Tema Claro */
body.tema_clara .theme-icon,
body.tema_clara .user-icon {
  background-color: var(--bg-tertiary);
  color: var(--icon-secondary);
  border: 1px solid var(--border-primary);
}

body.tema_clara .theme-icon:hover,
body.tema_clara .user-icon:hover {
  background-color: var(--bg-hover);
  color: var(--icon-primary);
}

/* Botão adicionar workspace - Tema Escuro */
body.tema_escura .premium-add-btn {
  background: linear-gradient(180deg, 
    var(--bg-secondary) 0%, 
    var(--bg-tertiary) 100%
  );
  border: 2px solid var(--border-primary);
  color: var(--icon-secondary);
}

body.tema_escura .premium-add-btn:hover {
  background: linear-gradient(180deg, 
    var(--bg-hover) 0%, 
    var(--bg-tertiary) 100%
  );
  border-color: var(--border-hover);
  color: var(--icon-primary);
}

/* Botão adicionar workspace - Tema Claro */
body.tema_clara .premium-add-btn {
  background: linear-gradient(180deg, 
    var(--bg-secondary) 0%, 
    var(--bg-tertiary) 100%
  );
  border: 2px solid var(--border-primary);
  color: var(--icon-secondary);
}

body.tema_clara .premium-add-btn:hover {
  background: linear-gradient(180deg, 
    var(--bg-hover) 0%, 
    var(--bg-tertiary) 100%
  );
  border-color: var(--border-hover);
  color: var(--icon-primary);
}
</style>
